/**
 *  account.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import * as actionTypes from '../actions/actionTypes';

const initialState = {
    account: ''
};

export const account = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_ACCOUNT:
            return {
                ...state,
                account: action.account
            };
        case actionTypes.CLEAR_ACCOUNT:
            return {
                ...state,
                account: ''
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/account.js